import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Option } from '../../../../../core/models/option.model';
import { Subscription, take } from 'rxjs';
import { QuotesService } from '../../core/quotes.service';
import { TooltipModule } from 'primeng/tooltip';
import { QuoteListItemComponent } from './quote-item/quote-item.component';
import { ItemEntry } from '../../core/quotes.model';
import { QuoteListService } from './core/quote-list.service';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'quotation-form',
  standalone: true,
  imports: [CommonModule, TooltipModule, QuoteListItemComponent, I18nModule],
  templateUrl: './quotation-form.component.html',
  styleUrl: './quotation-form.component.scss',
})
export class QuotationFormComponent implements OnInit, OnDestroy {
  frenquencies: Option[] = [];
  entries$ = this.quoteListService.entries$;
  subscription = new Subscription();

  constructor(
    private quotesFormService: QuotesService,
    private quoteListService: QuoteListService,
    private quotesService: QuotesService,
  ) {}

  ngOnInit(): void {
    this.getNewProduct();
    this.getFrequency();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getFrequency() {
    this.subscription.add(
      this.quotesService
        .getFrequency()
        .pipe(take(1))
        .subscribe(response => {
          this.frenquencies = response.frequencies || [];
        }),
    );
  }

  getNewProduct() {
    this.subscription.add(
      this.quotesFormService.getNewProduct().subscribe(product => {
        const entries = this.entries$.getValue();
        const productIndex = entries.findIndex(entry => entry!.product!.code === product.code);

        if (productIndex >= 0) {
          entries[productIndex].qty = (entries[productIndex].qty || 0) + 1;
        } else {
          entries.push({
            code: this.quotesFormService.generateID(),
            qty: 0,
            reqPrice: '',
            product,
          });
        }

        this.entries$.next(entries);
      }),
    );
  }

  handlerRemove(entry: ItemEntry) {
    const entries = this.entries$.getValue().filter(_entry => _entry.code !== entry.code);
    this.entries$.next(entries);
  }

  handlerChange(entry: ItemEntry) {
    const entries = this.entries$.getValue();
    const indexItem = entries.findIndex(_entry => _entry.code === entry.code);
    entries[indexItem] = entry;
    this.entries$.next(entries);
  }
}
